import { cn } from "@/lib/utils";

interface LanguageFlagsProps {
  language: number;
  className?: string;
}

// Bit flags: 1=Swedish, 2=English, 4=German, 8=French, 16=Spanish, 32=Italian
const SWEDISH = 1;
const ENGLISH = 2;
const GERMAN = 4;
const FRENCH = 8;
const SPANISH = 16;
const ITALIAN = 32;

export const LanguageFlags = ({ language, className }: LanguageFlagsProps) => {
  const flags: string[] = [];
  
  if (language & SWEDISH) flags.push("🇸🇪");
  if (language & ENGLISH) flags.push("🇬🇧");
  if (language & GERMAN) flags.push("🇩🇪");
  if (language & FRENCH) flags.push("🇫🇷");
  if (language & SPANISH) flags.push("🇪🇸");
  if (language & ITALIAN) flags.push("🇮🇹");
  
  if (flags.length === 0) return null;
  
  return (
    <span className={cn("inline-flex gap-0.5 text-sm", className)} title={getLanguageTitle(language)}>
      {flags.map((flag, i) => (
        <span key={i}>{flag}</span>
      ))}
    </span>
  );
};

function getLanguageTitle(language: number): string {
  const langs: string[] = [];
  if (language & SWEDISH) langs.push("Svenska");
  if (language & ENGLISH) langs.push("Engelska");
  if (language & GERMAN) langs.push("Tyska");
  if (language & FRENCH) langs.push("Franska");
  if (language & SPANISH) langs.push("Spanska");
  if (language & ITALIAN) langs.push("Italienska");
  return langs.join(", ");
}

// Export constants for use elsewhere
export const LANGUAGE_FLAGS = { SWEDISH, ENGLISH, GERMAN, FRENCH, SPANISH, ITALIAN };
